const TreeNode = require('../TreeNode');
const AICalc = require('../AICalc');

const Q_any_enemies = function (actor, battleState, moveTowards) {
  const node = new TreeNode(actor, battleState);

  node.branches[node.NO] = new TreeNode(null, null);

  if (actor.ai.settings.autoMove) {
    node.branches[node.YES] = moveTowards;
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  node.query = function () {
    const _bestTarget = AICalc.getBestMeleeTarget(actor, battleState);
    if (_bestTarget) {
      return node.branches[node.YES].query(_bestTarget);
    } else {
      return null;
    }
  };

  return node;
};
module.exports = Q_any_enemies;
